import React        from 'react';
import { Redirect } from 'react-router-dom';
import Company      from './Company';
import CompanyList  from './CompanyList';

export const CompanyConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path      : '/company/:view_type/:company_id',
            component : Company,
            permission: { component_name: 'company', permission_type: 'view_type' },
        },
        {
            path      : '/company/list',
            component : CompanyList,
            permission: { component_name: 'company', permission_type: 'list' },
        },
        {
            path      : '/company/:view_type/',
            component : Company,
            permission: { component_name: 'company', permission_type: 'view_type' },
        },
        {
            path      : '/company',
            component : () => <Redirect to="/company/list" />,
            permission: { component_name: 'company', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/company/CompanyConfig.js